import { Box, useMediaQuery, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import { Button } from '@/types/generated';
import ContentfulButton from '../ContentfulButton';
import TAGButton from '../TAGButton';
import { boxWrapperStyles, chatWithUsStyles, boxContainerStyles, boxContainerBackground, OpenChatButton } from './Chatbot.styles';
import ChatbotHeader from './ChatbotHeader';
import TAGSvgIcon from '../TAGSvgIcon/TAGSvgIcon';
import { useFacilityContext } from '@shared-components/context';
import { Maybe } from '@shared-components/types';
export interface ChatbotProps {
  url: string;
  isIconButton?: boolean;
  logoUrl?: string;
  featureList: string[];
  stickyFooterButton?: Maybe<Button>;
}
interface IStateObject {
  openPopup: boolean;
  showChatWithUs: boolean;
}
const Chatbot = ({
  url = '',
  isIconButton = false,
  logoUrl = '',
  featureList = [],
  stickyFooterButton
}: ChatbotProps) => {
  const [state, setState] = useState<IStateObject>({
    openPopup: false,
    showChatWithUs: true
  });
  useFacilityContext();
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('md'));
  const mobileOnly = isSmall && featureList?.includes('ameliaChatMobile') && !featureList?.includes('ameliaChatDesktop');
  const desktopOnly = !isSmall && featureList?.includes('ameliaChatDesktop') && !featureList?.includes('ameliaChatMobile');
  const mobileAndDesktop = featureList?.includes('ameliaChatDesktop') && featureList?.includes('ameliaChatMobile');
  useEffect(() => {
    if (isSmall && state.openPopup) {
      document.body.classList.add('chat-open');
    } else {
      document.body.classList.remove('chat-open');
    }
  }, [isSmall, state.openPopup]);
  useEffect(() => {
    // Amelia iframe message listener
    const handleMessage = (event: MessageEvent) => {
      const {
        origin
      }: {
        origin: string;
        data: {
          [key: string]: Maybe<string | boolean | number | undefined>;
        };
      } = event;
      if (!origin.includes('amelia')) {
        return;
      }
    };
    globalThis.window.addEventListener('message', handleMessage);
    return () => {
      globalThis.window.removeEventListener('message', handleMessage);
    };
  }, []);
  const handleClick = () => {
    setState({
      ...state,
      openPopup: !state.openPopup
    });
  };
  const handleClose = () => {
    setState({
      ...state,
      openPopup: false
    });
  };
  if (!state.showChatWithUs) {
    return null;
  }
  if (!stickyFooterButton && !featureList?.includes('ameliaChatMobile') && !featureList?.includes('ameliaChatDesktop')) {
    return null;
  }
  const chatConditionSet = mobileAndDesktop || isSmall && mobileOnly || !isSmall && desktopOnly;
  const chatPopup = state.openPopup && <Box sx={{
    ...boxContainerStyles(isSmall)
  }}>
			{isSmall && <Box sx={{
      ...boxContainerBackground(isSmall)
    }} {...isSmall && {
      onClick: handleClose
    }} />}
			<Box data-testid="section_chatbot" sx={{
      ...boxWrapperStyles(theme, isSmall)
    }}>
				<ChatbotHeader handleClose={handleClose} logoUrl={logoUrl} />
				<iframe allow="geolocation; microphone" src={url} id="Amelia-chatbot-frame" title="Amelia-chatbot" data-gtm-yt-inspected-19="true" />
			</Box>
		</Box>;
  if (stickyFooterButton) {
    return <>
				{chatPopup}
				<ContentfulButton onClick={handleClick} dataTestId="sticky_amelia_chat_icon_button" {...stickyFooterButton} isSmallScreen={isSmall} />
			</>;
  }
  return <>
			{chatConditionSet ? <>
					{chatPopup}
					{isIconButton ? <TAGButton sx={OpenChatButton} disableTouchRipple onClick={handleClick} dataTestId="amelia_chat_icon_button">
							<TAGSvgIcon icon="ChatBubbleOutline" htmlColor="#FFF" fill="#FFF" width="34" height="34" />
						</TAGButton> : <TAGButton size="S" variant="primaryAccent1" onClick={handleClick} dataTestId="amelia_chat_button" startIcon={<TAGSvgIcon icon="ChatBubbleOutline" dataTestId="ChatBubbleOutlineIcon" size={25} />} sx={chatWithUsStyles}>
							Chat with us
						</TAGButton>}
				</> : null}
		</>;
};
export default Chatbot;